const destinations = [
  { city: "Cancún", country: "Mexico", time: "3h from MCI", icon: "ri-sun-line", popular: true },
  { city: "Toronto", country: "Canada", time: "2h+ from MCI", icon: "ri-building-line", popular: false },
  { city: "London", country: "UK", time: "9h from MCI", icon: "ri-bank-line", popular: false },
  { city: "Montego Bay", country: "Jamaica", time: "3.5h from MCI", icon: "ri-ship-line", popular: true },
  { city: "Frankfurt", country: "Germany", time: "10h from MCI", icon: "ri-briefcase-line", popular: false },
  { city: "Monterrey", country: "Mexico", time: "3h from MCI", icon: "ri-store-line", popular: false },
];

export default function LeeSummitDestinationsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Popular Destinations</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Lee&apos;s Summit Travelers Are Going
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            From Cancún beach getaways to cross-border business meetings in Monterrey, Lee&apos;s Summit and Jackson County travelers have one common problem: passport urgency. We solve it.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-5">
          {destinations.map((d, i) => (
            <div key={i} className="relative bg-white border border-gray-200 rounded-lg p-5 flex flex-col gap-3 hover:border-[#F6C344] transition-all">
              {d.popular && (
                <span className="absolute top-3 right-3 bg-[#F6C344] text-[#1A365D] text-xs font-bold px-2 py-0.5 rounded-full">Popular</span>
              )}
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                <i className={`${d.icon} text-[#1A365D] text-lg`}></i>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.city}</h3>
                <p className="text-gray-400 text-xs">{d.country}</p>
              </div>
              <p className="text-[#F6C344] text-xs font-semibold">{d.time}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}